import { render, staticRenderFns } from "./GardenGroupInfo.vue?vue&type=template&id=eb6160f2&"
import script from "./GardenGroupInfo.vue?vue&type=script&lang=js&"
export * from "./GardenGroupInfo.vue?vue&type=script&lang=js&"
import style0 from "./GardenGroupInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports